import { render, staticRenderFns } from "./PracticeAreaFormBlock.vue?vue&type=template&id=e3de3472"
import script from "./PracticeAreaFormBlock.vue?vue&type=script&lang=js"
export * from "./PracticeAreaFormBlock.vue?vue&type=script&lang=js"
import style0 from "./PracticeAreaFormBlock.vue?vue&type=style&index=0&id=e3de3472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports